<script>
    import {fade} from "svelte/transition"
import DonationBoxMenu from "./DonationBoxMenu.svelte";
    export let hide;
    export let menu;
    export let addDonationBoxBlock;
</script>
<div class="back-button" on:click={hide}>&larr; Back</div>
<div style="display: block;width: 100%;text-align:left;" in:fade>
{#if menu == 'donationbox'}
<DonationBoxMenu {addDonationBoxBlock} />
{/if}
</div>
<style>
    .back-button {
        text-align: left;
        margin-bottom: 20px;
        cursor: pointer;
    }
</style>